import React, { Component } from 'react';


export class UserCard extends Component{
    render(){
        return (
            <div className="card card-user">
                <div className="image">
                    <img src={this.props.bgImage} alt="..."/>
                </div>
                <div className="content">
                    <div className="author">
                            <img className="avatar border-gray" src={this.props.avatar} alt="..." style={ this.props.color? { borderColor: this.props.color} : null }/>
                            <h4 className="title">
                                {this.props.name}
                                <br />
                                <small>{this.props.userName}</small>
                                <br />
                                <small>{this.props.manualScoreName}: {this.props.manualScoreValue}</small>
                                <br/>
                                <small>Calificación GCare: {this.props.autoScoreValue}</small>
                            </h4>
                    </div>
                    <p className="description text-center">
                        {this.props.description}
                    </p>
                </div>
                <hr />
                <div className="text-center">
                    {this.props.socials}
                </div>
            </div>
        );
    }
}

export default UserCard;
